import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';

export function insertWhiteUrl(white) {
    return Post(envConfig.formalServer + "/cotton/insertWhiteUrl", white)
}

export function deleteWhiteUrl(idList) {
    return Post(envConfig.formalServer + "/cotton/deleteWhiteUrl", {idList})
}

export function updateWhiteUrl(white) {
    return Post(envConfig.formalServer + "/cotton/updateWhiteUrl", white)
}

export function queryWhiteUrlList(whiteDTO) {
    return Post(envConfig.formalServer + "/cotton/queryWhiteUrlList", whiteDTO)
}